<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="p-card-field">
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Username <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-if="mode=='edit'" disabled v-model="user.username" id="username" type="text" class="p-col-width-a" placeholder="Input" />
            <InputText v-else v-model="user.username" id="username" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Fullname <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="user.fullname" id="fullname" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Phone</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="user.phone" id="phone" type="text" @keypress="isPhone($event)" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Permission <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <input class="input_tmp_validator" id="group_id_va">
            <Dropdown class="p-col-width-a" v-model="user.group_id" :options="list_group_role"
              optionValue="id" optionLabel="name" placeholder="Select"
            />
          </div>
        </div>
        <div class="p-field p-grid in-d">
          <label v-if="mode=='edit'" class="p-col-fixed">Password</label>
          <label v-else class="p-col-fixed">Password <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-if="mode=='edit'" v-model="user.password" id="password" type="password" class="p-col-width-a" placeholder="" />
            <InputText v-else v-model="user.password" id="password" type="password" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field in-d">
          <label class="container">
            <input v-if="user.active==true" type="checkbox" class="cus-checkbox" checked="checked" v-on:change="funtionUpdate($event)">
            <input v-else type="checkbox" class="cus-checkbox" v-on:change="funtionUpdate($event)">
            <span class="checkmark"></span>
            <span>Active</span>
          </label>
        </div>      
      </div>
      
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
              label="Cancel"
              @click="backToList()"
              class="p-button-warning"
              style="width: 120px !important;"
          />
          <Button
              label="Save"
              @click="saveData()"
              class="p-button-success"
              style="width: 120px !important;"
          />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";

export default {
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {

      user:{
        fullname: '',
        phone: '',
        username: '',
        email: '',
        password: '',
        password_confirm: '',
        group_id:null,
        active : true
      },
      formMode: this.mode,
      list_group_role:[],
      saving:false,
    }
  },
  async mounted() {
    //var that =this;
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.modelthis.model:this.model",this.model)
      var dataGroupUser = await this.getGroupUser(this.model.id);
      if (dataGroupUser && dataGroupUser.length){
        this.model.group_id = dataGroupUser[0].group_id;
      }
      this.user = this.$commonFuction.convertJsonObject(this.model);
      this.user.username = this.user.account
      this.$CoreService.getAccountByUid(this.model.id).then(res => {
        console.log("getAccount",res)
        if (res && res.length){
          this.user.user_id = res[0].uid;
        }
      });
    }
    this.listGroupRole().then(res => {
      console.log("resres",res)
      this.list_group_role = res;
    });

  },
  methods: {
    funtionUpdate(e){
      var check = e.target.checked;
      this.user.active = check
    },
    async listGroupRole() {
      var where = {
        active: {_eq: true},
        deleted: {_eq: false}
      };
      var order_by = {id: 'desc'};
      var listData = await  this.$CoreService.getListData('group',where,null,null,order_by);
      return listData;
    },
    async getGroupUser(uid) {
      var table_cer = 'group_user';
      var where = {uid: {_eq: uid}};
      var gqLQueryList =await DataServices.getList(table_cer);
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key:where ,
        }
      });
      var listData = resData.data[table_cer];
      return listData;
    },
    /*async getAccount(uid) {
      var table_cer = 'accounts';
      var where = {uid: {_eq: uid}};
      var gqLQueryList =await DataServices.getList(table_cer);
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key:where ,
        }
      });
      var listData = resData.data[table_cer];
      return listData;
    },*/
    getAddressData: function (addressData, placeResultData, id) {
      this.addressData = addressData;
      this.placeResultData = placeResultData;
      console.log(JSON.stringify(addressData));
      console.log(JSON.stringify(placeResultData));
      console.log(id);
    },
    backToList() {
      this.$emit('back');
    },
    async checkEmailAdminExist(email,model) {//check tồn tại sdt
      if (!this.$commonFuction.isEmpty(email)) {
        var where = {
          account: {'_eq': email},
          type: {'_eq': 'EMAIL'},
          deleted: {'_eq': false}
        }
        if (model !== undefined) where = Object.assign(where, {uid: {'_neq': model.id}})

        var {data} = await this.$apollo.query({
          query: DataServices.getList('accounts', {"fields" : "id, account, type"}),
          variables: {
            where_key: where
          },
          fetchPolicy: "network-only"
        });

        // console.log(data)
        return data && data[Object.keys(data)].length > 0
      }
    },
    async isPhone(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async validateData() {
      //kiểm tra username tồn tại hay chưa
      var username = document.getElementById("username");
      var text_validator_username = "";
      if (this.$commonFuction.isEmpty(this.user.username)) {
        text_validator_username = 'Username is not empty'
      }
      if (!this.$commonFuction.isEmpty(text_validator_username)) {
        username.setCustomValidity(text_validator_username);
      } else {
        username.setCustomValidity("");
      }
      var fullname = document.getElementById("fullname");
      if(this.$commonFuction.isEmpty(this.user.fullname)){
        fullname.setCustomValidity("Fullname is not empty");
      }else{
        fullname.setCustomValidity("");
      }
      // var phone = document.getElementById("phone");
      // if(this.$commonFuction.isEmpty(this.user.phone)){
      //   phone.setCustomValidity("phone không để trống");
      // }else{
      //   phone.setCustomValidity("");
      // }
      var group_id_va = document.getElementById("group_id_va");
      if (this.$commonFuction.isEmpty(this.user.group_id)) {
        group_id_va.setCustomValidity("Select permission");
      } else {
        group_id_va.setCustomValidity("");
      }
      var password = document.getElementById("password");
      if(this.mode == 'add'){
        if (this.$commonFuction.isEmpty(this.user.password)){
          password.setCustomValidity("Password is not empty");
        } else {
          if(this.user.password.length < 6){
            password.setCustomValidity("Password must have 6 characters or more");
          }else{
            password.setCustomValidity("");
          }
        }
        if (this.$commonFuction.isEmpty(text_validator_username)) {
          var account_exist = await this.checkEmailAdminExist(this.user.username.trim(), this.model);
          if(account_exist == true){
            text_validator_username = 'The account already exists'
          }else{
            text_validator_username = "";
          }
          username.setCustomValidity(text_validator_username);
        }
      }else{
        if (this.$commonFuction.isEmpty(this.user.password)){
          password.setCustomValidity("");
        } else {
          if(this.user.password.length < 6){
            password.setCustomValidity("Password must have 6 characters or more");
          }else{
            password.setCustomValidity("");
          }
        }
      }

      // var text_validator_email = "";
      // if (!this.$commonFuction.isEmpty(this.user.email)) {
      //   console.log("this.model:",this.model);
      //   this.account_exist = await this.checkEmailAdminExist(this.user.email.trim(), this.model);
      //   if (this.account_exist) {
      //     text_validator_email = this.$constants.MSG_TEXT.EMAIL_EXIST_SYSTEM_MSG;
      //   }
      // }

      // var email = document.getElementById("email");
      // if (!this.$commonFuction.isEmpty(text_validator_email)) {
      //   email.setCustomValidity(text_validator_email);
      // } else {
      //   email.setCustomValidity("");
      // }
      // var password_confirm_text_va = "";
      // if (!this.$commonFuction.isEmpty(this.user.password) && !this.$commonFuction.isEmpty(this.user.password_confirm)) {
      //   if (this.user.password !== this.user.password_confirm) {
      //     password_confirm_text_va = this.$constants.MSG_TEXT.PASSWORD_NOT_MATCH_MSG;
      //     //password_confirm.setCustomValidity(this.$constants.MSG_TEXT.PASSWORD_NOT_MATCH_MSG);
      //   }
      // }
      // var password_text_va = "";
      // if (this.formMode !== 'add') {
      //   if (this.user.email != this.user.email_old){
      //     //trường hợp khác thì bắt nhập lại mật khẩu
      //     if (this.$commonFuction.isEmpty(this.user.password)){
      //       password_text_va = this.$constants.MSG_TEXT.INPUT_INVALID_MSG;
      //     }
      //     if (this.$commonFuction.isEmpty(this.user.password_confirm)){
      //       password_confirm_text_va = this.$constants.MSG_TEXT.INPUT_INVALID_MSG
      //     }
      //   }else {
      //     //
      //     if (!this.$commonFuction.isEmpty(this.user.password)){
      //       //trường hợp thay đổi thì bắt nhập passcomfirt
      //       if (this.$commonFuction.isEmpty(this.user.password_confirm)){
      //         password_confirm_text_va = this.$constants.MSG_TEXT.INPUT_INVALID_MSG
      //       }
      //     }
      //     if (!this.$commonFuction.isEmpty(this.user.password_confirm)){
      //       //trường hợp thay đổi thì bắt nhập password
      //       if (this.$commonFuction.isEmpty(this.user.password)){
      //         password_text_va = this.$constants.MSG_TEXT.INPUT_INVALID_MSG;
      //       }
      //     }
      //   }
      // }
      // var password_confirm = document.getElementById("password_confirm");
      // if (!this.$commonFuction.isEmpty(password_confirm_text_va)){
      //   password_confirm.setCustomValidity(password_confirm_text_va);
      // }else {
      //   password_confirm.setCustomValidity("");
      // }

      // var password = document.getElementById("password");
      // if (!this.$commonFuction.isEmpty(password_text_va)){
      //   password.setCustomValidity(password_text_va);
      // } else {
      //   password.setCustomValidity("");
      // }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async getUserByPhoneNumber(phoneNumber) {
      // var phone = phoneNumber;
      // if (phoneNumber[0] === "0") {
      //   phone = phone.substring(1);
      // }
      // phone = phone.replace(' ', '');
      // phone = "+84" + phone;
      let query = `mutation MyMutation {
        checkPhoneNumber(phone: "${this.convertPhone(phoneNumber)}") {
          info
        }
      }`;
      await this.$apollo.mutate({
        mutation: gql(query)
      }).then(async(res) => {
        // console.log('=========> checkPhoneNumber: ', res)
        if (res) {
          this.firebaseID = res.data.checkPhoneNumber.info.uid
          await this.$apollo.query({
            query: DataServices.getList('users', {"fields" : "id"}),
            variables: {
              where_key: {
                phone: {'_eq': this.phone},
                deleted: {'_eq': false}
              }
            },
            fetchPolicy: "network-only"
          }).then((res) => {
            if (res && res.data.users.length > 0) this.userID = res.data.users[0].id
            else this.userID = null
            // console.log(this.userID)
          }).catch((error) => {
            console.log('ERROR: ', error.message)
          })
        }
      }).catch((error) => {
        console.log('ERROR: ', error.message)
        // CHƯA CÓ FIREBASE ID
        this.firebaseID = null
        this.userID = null
      })
    },
    async checkPhoneExist() {
      if (this.phone !== undefined && this.phone !== "") {
        // var phone = this.phone;
        // if (this.phone[0] === "0") {
        //   phone = phone.substring(1);
        // }
        // phone = phone.replace(' ', '');
        // phone = "+84" + phone;

        var where = {
          account: {'_eq': this.phone},
          type: {'_eq': 'PHONE'},
          deleted: {'_eq': false}
        }
        if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
        var {data} = await this.$apollo.query({
          query: DataServices.getList('accounts', {"fields" : "id, account, type"}),
          variables: {
            where_key: where
          },
          fetchPolicy: "network-only"
        })
        // console.log(data)
        return data && data[Object.keys(data)].length > 0
      }
    },
    async saveData() {

      /* if(this.saving == true){
         return;
       }
       this.saving = true;*/
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        // this.saving = false;
        this.$commonFuction.is_loading(false);
        return
      }

      if (!this.account_exist) {
        var params = {
          user: this.user,
          // images: this.images,
          // imagesDeletes: this.imagesDeletes,
        }
        // console.log('saveData', params)
        this.$emit('save', params);
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Vui lòng upload file ảnh có định dạng sau: jpeg, jpg, gif, png");
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === '') {
              this.imagesDeletes.push(this.images[0])
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
            // console.log(this.images)
            await this.validateData()
          }
        }
      }
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === '') this.imagesDeletes.push(img)
    }
  },
  /*apollo: {
    category: {
      query() {
        return DataServices.getList('category', {"fields" : "id name"});
      },
      update(data) {
        if(data.category){
          this.categories = data.category
        }
      },
      fetchPolicy: "network-only"
    },
  }*/
}
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}
.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}
.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}
.p-multiselect-label-container{
  height: 40px;
}
.p-col-width-a{
  max-width: 600px
}
.in-d {
  font-weight: 700;
}
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ccc;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #e95d57;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.container input:checked ~ .checkmark{
  background-color:#E73725 !important; ;
}
</style>
